import { NgModule } from '@angular/core';
import { AppCoreModule } from 'src/app/core/app-core.module';
import { CreateNewMessageComponent } from './create-new-message.component';

@NgModule({
  declarations: [CreateNewMessageComponent],
  imports: [AppCoreModule],
  exports: [CreateNewMessageComponent]
})
export class CreateNewMessageModule {}
